// extracted by mini-css-extract-plugin
module.exports = {"MenuToggle":"MenuToggle_MenuToggle__1G1sS","open":"MenuToggle_open__mLkNM"};